export const number_format = (num) => {
  if (num == null || isNaN(Number(num))) return "0.00";

  const formattedNumber = Number(num).toFixed(2);
  const [integerPart, decimalPart] = formattedNumber.split(".");

  return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + decimalPart;
};
